import { AtomLoadingPopup, ErrorPage, W } from '@miotech/shared';
import useRedux from 'hooks/useRedux';
import React, { useCallback, useEffect, useState } from 'react';
const PermissionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [authenticating, setAuthenticating] = useState(true);
  const [errorCode, setErrorCode] = useState(undefined);
  const [errorMessage, setErrorMessage] = useState(undefined);
  const { dispatch } = useRedux(s => s.userRole);

  // const [loading, setLoading] = useState<boolean>();
  const fetchUserPermission = useCallback(async () => {
    try {
      await dispatch.userRole.updateAsync();
      // dispatch.quotaRemain.updateAsync();
      // dispatch.greenLevel.updateAsync();
      setAuthenticated(true);
      setAuthenticating(false);
    } catch (error: any) {
      if (error.detailCode === 'SYSTEM-USER-00001' && window.location.href.includes('/gvi/change-password')) {
        setAuthenticated(true);
      } else {
        setAuthenticated(false);
        setErrorCode(error.code || 500);
        setErrorMessage(error.message || '系统异常，请联系管理员');
      }

    };
  }, [dispatch.userRole]);
  useEffect(() => {
    fetchUserPermission();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (authenticated) {
    return <div>{children}</div>;
  }

  if (authenticating) {
    return <AtomLoadingPopup visible />;
  }
  if (errorCode === 401) {
    return (
      <AtomLoadingPopup visible text={W('shared.authenticated.redirect')} />
    );
  }
  return <ErrorPage errorCode={errorCode} message={errorMessage} />;
};

export default PermissionsProvider;
